module.exports = __webpack_public_path__ + "static/media/cservice.779ecd3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cservice.jpg
// module id = 182
// module chunks = 0